import "ckeditor5/ckeditor5.css";
import {useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { PostCommentAPI } from "../../../../../../../store/api/get/Board/Board";
import {SET_COMMENT} from "../../../../../../../store/constants";
import {Editor} from "../../../../../../../components/Editor/Editor";
import DOMPurify from "dompurify";
import {SOCKET} from "../../../../../../../URL";
import {User} from "../../../../../../../components/User/User";

export const Comments = ({ card, focusEditor, setFocusEditor }) => {
    const user = useSelector((state) => state.user.user);
    const dispatch = useDispatch();
    const editorRef = useRef(null);

    const [localComments, setLocalComments] = useState([]);
    const [comments, setComments] = useState(null);
    const [isEditComments, setIsEditComments] = useState(false);
    console.log(card);
    const handleSaveComments = async () => {
        if (!comments?.html?.trim()) {
            setIsEditComments(false);
            return;
        }

        try {
            const result = await PostCommentAPI({
                ...comments,
                card_id: card?.id,
                created_at: Date.now(),
                user_id: user?.id,
            });

            const newComment = {
                id: result.comment?.id || result.comment_id,
                card_id: card?.id,
                text: result.comment?.text || result.html || comments.html,
                images: result.comment?.images || result.images || [],
                user_id: user?.id,
                email: user?.email,
                gradient: user?.settings?.bg_gradient,
                created_at: result.comment?.created_at || Date.now(),
            };

            dispatch({
                type: SET_COMMENT,
                payload: newComment,
            });

            SOCKET.emit("add_comment", newComment);

            setComments(null);
            setIsEditComments(false);

            if (editorRef.current) {
                editorRef.current.setData("");
            }
        } catch (error) {
            console.error("Comment save error:", error);
        }
    };
    const handleDescription = (e, editor) => {
        const html = editor.getData();
        const editableElement = editor.ui.view.editable.element;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const editorWidth = editableElement.getBoundingClientRect().width || 1;
        const editorFigures = editableElement.querySelectorAll("figure.image");

        const resizeWidths = [];

        doc.querySelectorAll("figure.image").forEach((figure, index) => {
            const img = figure.querySelector("img");
            if (!img) return;

            const editorFigure = editorFigures[index];

            let width = null;

            if (editorFigure) {
                const figureWidth = editorFigure.getBoundingClientRect().width;
                const widthPercent = Math.round((figureWidth / editorWidth) * 100);

                width = `${widthPercent}%`;
                resizeWidths[index] = width;
            }

            img.removeAttribute("width");
            img.removeAttribute("height");
            img.removeAttribute("style");

            if (width) {
                img.setAttribute("data-resize-width", width);
                img.style.width = width;
            } else {
                img.style.width = "100%";
            }

            img.style.height = "auto";

            // figure թողնում ենք, չենք ջնջում
        });

        doc.querySelectorAll("img").forEach((img, index) => {
            if (!img.style.width) {
                const width = resizeWidths[index] || "100%";
                img.setAttribute("data-resize-width", width);
                img.style.width = width;
            }

            img.style.height = "auto";
        });

        setComments({
            card_id: card?.id,
            html: doc.body.innerHTML,
            resize_widths: resizeWidths,
            is_edit: !!isEditComments,
        });
    };

    return (
        <aside className="cardModal__sidebar">
            <div className="cardModal__sidebarHeader">
                <h3>Comments and activity</h3>
            </div>

            <Editor getEditorData={null} handleEditor={handleDescription} setFocusEditor={setFocusEditor}/>

            <div className="cardModal__editorFooter">
                <div className="cardModal__editorFooterLeft">
                    <button
                        type="button"
                        className="cardModal__saveBtn"
                        onClick={handleSaveComments}
                    >
                        Save
                    </button>

                    <button
                        type="button"
                        className="cardModal__cancelBtn"
                        onClick={() => {
                            setComments(null);
                            setIsEditComments(false);

                            if (editorRef.current) {
                                editorRef.current.setData("");
                            }
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>

            <div className="cardModal__activityList">
                {card?.comments?.map((el) => (
                    <div className="cardModal__activityItem" key={el.id}>
                       <User el={el} className="headerUserAvatar" />

                        <div className="cardModal__activityContent">
                            <p>
                                <strong>{el.email}</strong>{" "}
                                added this card
                            </p>

                            <span className="cardModal__activityDate">
                                {new Date(el.created_at).toLocaleString("en-US", {
                                    month: "short",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true,
                                })}
                            </span>

                            {el.text && (
                                <div
                                    className="cardModal__commentText"
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(el?.text) }}
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </aside>
    );
};